import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ e("path", {
  fill: "#D80027",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ e("path", {
  fill: "#000",
  d: "M31.304 14.844H24.06A2.609 2.609 0 1 0 20 11.601a2.609 2.609 0 1 0-4.06 3.243H8.696c0 1.921 1.673 3.479 3.594 3.479h-.116a3.478 3.478 0 0 0 3.478 3.478c0 .622.164 1.205.45 1.71l-2.885 2.886 2.214 2.213 3.14-3.14c.123.045.25.081.381.106l-1.897 4.284L20 33.044l2.945-3.184-1.898-4.284c.132-.025.26-.06.382-.106l3.14 3.14 2.214-2.214-2.886-2.885c.287-.505.45-1.088.45-1.71a3.478 3.478 0 0 0 3.48-3.479h-.117c1.921 0 3.594-1.557 3.594-3.478Z"
}, null, -1), s = [
  o,
  n
];
function a(r, i) {
  return t(), l("svg", c, [...s]);
}
const h = { render: a };
export {
  h as default,
  a as render
};
